import type { Review } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';

export const GTM_ARTICLE_REVIEWS = (
  page: number,
  filter: number | null,
  onlyB2B: boolean,
  sort: string,
  reviews: Review[],
  total: number,
) => ({
  event: 'interaction_view product reviews',
  e_category: 'navigation',
  e_action: 'View product reviews',
  event_trigger: 'product page',
  amp_event_name: 'View product reviews',
  interaction_hit: 'False',
  current_page: page,
  ratings_filter: filter,
  sorting: sort,
  only_b2b: onlyB2B,
  page_type: 'product',
  pr_review_count: total,
  review_pro_count: reviews.filter((review) => review.isB2b).length,
  has_useful_reviews: reviews.some((review) => review.votes > 0),
});
